import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Drawer } from '@ahmdigital/ui';
import { Formik } from 'formik';
import { isEmpty } from 'lodash/fp';
import React, { useRef } from 'react';
import styled from 'styled-components';

import { DRAWER_IDS } from '../../ahm-constants/ui';
import buildSubmitHandler from './utils/build-submit-handler';
import CustomerActions from '../../actions/customer';
import CustomerForm from './components/customer-form';
import DrawerActions from '../../actions/drawer';
import Footer from './components/footer';
import pricingDrawerSchema, { PricingDrawerSchemaType } from './schema';
import selectCurrentDrawer from '../../selectors/select-current-drawer';
import selectCustomer from '../../selectors/select-customer';
import selectCustomerFormInitialValues from './selectors/select-customer-form-initial-values';
import type { PricingDrawerActions } from './types';

type PricingDrawerProps = {
  actions: PricingDrawerActions;
  customer: {
    scale: string;
    rebate: boolean;
  };
  drawer: string;
  initialValues: PricingDrawerSchemaType;
  isProductWithHospitalServices: boolean;
  match?: {
    params: {
      needsProductType: string;
      needsType: string;
    };
  };
  product?: {};
  showIncomeOptions?: boolean;
};

const StyledScrollMarginDiv = styled.div`
  scroll-margin-top: 5rem;
`;

const PricingDrawer = ({
  actions,
  customer,
  // @ts-expect-error - Automatic, Please fix when editing this file
  drawer = null,
  initialValues,
  isProductWithHospitalServices,
  // @ts-expect-error - Automatic, Please fix when editing this file
  match = null,
  showIncomeOptions = true,
  product = {},
}: PricingDrawerProps) => {
  const formRef = useRef(null);
  const closeDrawer = () => {
    actions.drawer.closeDrawer();
  };

  const drawerFooter = (
    <Footer handleClose={closeDrawer} isProductWithHospitalServices={isProductWithHospitalServices} />
  );
  const isOpen = drawer === DRAWER_IDS.CHANGE_DETAILS;

  return (
    <Formik<PricingDrawerSchemaType>
      enableReinitialize
      validationSchema={pricingDrawerSchema}
      initialValues={initialValues}
      onSubmit={(values) => {
        buildSubmitHandler({ actions, customer, formValues: values, initialValues });
      }}
    >
      {({ errors, isSubmitting, submitCount }) => {
        if (isSubmitting && !isEmpty(errors)) {
          // @ts-expect-error - Automatic, Please fix when editing this file
          formRef.current.scrollIntoView({
            behavior: 'smooth',
          });
        }
        return (
          <Drawer title="Change details" isOpen={isOpen} toggleMenu={actions.drawer.closeDrawer} footer={drawerFooter}>
            <StyledScrollMarginDiv ref={formRef}>
              <CustomerForm
                isProductWithHospitalServices={isProductWithHospitalServices}
                hasSubmitAttempt={Boolean(submitCount)}
                match={match}
                product={product}
                showIncomeOptions={showIncomeOptions}
              />
            </StyledScrollMarginDiv>
          </Drawer>
        );
      }}
    </Formik>
  );
};

type RootReduxState = {};

const mapStateToProps = (state: RootReduxState) => ({
  customer: selectCustomer(state),
  drawer: selectCurrentDrawer(state),
  initialValues: selectCustomerFormInitialValues(state),
  scale: selectCustomer(state).scale,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  actions: {
    customer: bindActionCreators(CustomerActions, dispatch),
    drawer: bindActionCreators(DrawerActions, dispatch),
  },
});

// @ts-expect-error - Automatic, Please fix when editing this file
export default connect(mapStateToProps, mapDispatchToProps)(PricingDrawer);

export { PricingDrawer as PricingDrawerForTest };
